import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { Fragment, useContext, useMemo } from 'react'
import { useFieldArray } from 'react-hook-form';
import { ProviderExpensePlan } from './FundExpensesPlanForm';
import { BtnAdd, BtnDelete } from 'components/Button/ButtonAll';
import { parseFloatCheckValue } from '../Ticket/fnTickit';
import { TextBoxItem } from 'components/Input/TextBox';
import _ from "lodash";
import { debounce } from 'lodash';
import { FnDialog, I18n, formatNumber } from 'utilities/utilities';
import { I18NextNs } from 'enum/enum';
import InputReactNumber from '../InputReactNumber';

export default function TableHookForm({ keyId }) {

    const {
        arrMonth,
        form,
    } = useContext(ProviderExpensePlan);

    const { control, setValue, watch, getValues, reset } = form;
    const { fields } = useFieldArray({
        control,
        name: "lstExpensePlan"
    });

    const watchFieldArray = watch("lstExpensePlan");


    const controlledFields = useMemo(() => {
        return fields.map((field, index) => {
            return {
                ...field,
                ...watchFieldArray[index]
            };
        });
    }, [fields, watchFieldArray])

    return (
        <TableContainer id='table-pinned' sx={{ maxHeight: "80vh" }} component={Paper} >
            <Table sx={{ minWidth: 1400 }} stickyHeader >
                <TableHead>
                    <TableRow>
                        <TableCell className="sticky-cell pad-0 head-color head-z400" component="th" padding='none' style={{ minWidth: '470px', width: '470px' }}>
                            <TableCell className='cell-in-sticky border-l head-color' padding='none' style={{ minWidth: '110px', width: '110px' }}></TableCell>
                            <TableCell className='cell-in-sticky border-l head-color' padding='none' style={{ minWidth: '60px', width: '60px' }}>ลำดับที่</TableCell>
                            <TableCell className='cell-in-sticky border-l head-color' padding='none' style={{ minWidth: '300px', width: '300px' }}>รายการ</TableCell>
                        </TableCell>
                        {
                            arrMonth.map((month: string, indexM: number) => {
                                let isFillColor = [3, 7, 11, 15].includes(indexM);
                                return (
                                    <TableCell
                                        key={month}
                                        component="th"
                                        padding='none'
                                        className={isFillColor ? 'head-z300' : "head-color head-z300"}
                                        sx={{
                                            minWidth: '150px',
                                            width: '150px',
                                            backgroundColor: isFillColor ? '#70b603 !important' : "head-color"
                                        }}
                                    >
                                        {month}
                                    </TableCell>
                                )
                            })
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        controlledFields != null && controlledFields.length > 0 ?
                            <>

                                {controlledFields.map((itemRowLevel1, indexLevel1) => {
                                    let keyCellTable = keyId + itemRowLevel1.nID;
                                    return (
                                        <Fragment key={keyCellTable}>
                                            <NestedArrayLevel1 keyId={keyId} itemRowLevel1={itemRowLevel1} indexLevel1={indexLevel1} {...{ control, reset, getValues, watch, setValue, }} />
                                        </Fragment>
                                    )
                                })}
                            </>
                            :
                            <TableRow key={"r-no-data"}>
                                <TableCell align="center" colSpan={20}>
                                    ไม่พบข้อมูล
                                </TableCell>
                            </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>

    )
}

function NestedArrayLevel1({ itemRowLevel1, indexLevel1, control, setValue, watch, getValues, reset, keyId }) {

    const {
        arrMock,
        calIndexOld,
        findMaxID,
        isView,
    } = useContext(ProviderExpensePlan);
    const DialogFn = FnDialog();

    const { fields, append: appendTwo, remove: removeTwo } = useFieldArray({
        control,
        name: `lstExpensePlan.${indexLevel1}.lstSubLevel`
    });

    const watchFieldArray = watch(`lstExpensePlan.${indexLevel1}.lstSubLevel`);
    const controlledFieldsLevel2 = useMemo(() => {
        return fields.map((field, index) => {
            return {
                ...field,
                ...watchFieldArray[index]
            };
        });

    }, [fields, watchFieldArray])

    const handleChangeValueLevelOne = (eValue: any, indexMonth: any, indexRow: any, itemTable: any) => {
        handleLevelOneInDebounced.cancel();
        handleLevelOneInDebounced(eValue, indexMonth, indexRow, itemTable);
    }

    const handleLevelOneInDebounced = debounce((eValue: any, indexMonth: number, keyRow: { value: number; }, itemTable) => {
        // Your delayed logic or state update here
        let sumQ1 = parseFloatCheckValue(itemTable.nQ1) ?? 0;
        let sumQ2 = parseFloatCheckValue(itemTable.nQ2) ?? 0;
        let sumQ3 = parseFloatCheckValue(itemTable.nQ3) ?? 0;
        let sumQ4 = parseFloatCheckValue(itemTable.nQ4) ?? 0;
        let nTotal = 0;
        keyRow.value = parseFloatCheckValue(eValue);
        if ([0, 1, 2].includes(indexMonth)) {
            // Q1
            sumQ1 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [1, 2, 3].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.nQ1`, sumQ1)
        }
        else if ([3, 4, 5].includes(indexMonth)) {
            // Q2
            sumQ2 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [4, 5, 6].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.nQ2`, sumQ2)
        }
        else if ([6, 7, 8].includes(indexMonth)) {
            // Q3
            sumQ3 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [7, 8, 9].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.nQ3`, sumQ3)
        }
        else {
            // Q4
            sumQ4 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [10, 11, 12].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.nQ4`, sumQ4)
        }
        nTotal = sumQ1 + sumQ2 + sumQ3 + sumQ4;

        setValue(`lstExpensePlan.${indexLevel1}.nTotal`, nTotal)
        reset({
            ...watch(),
        });
    }, 500);


    const handleAddRowlevelTwo = (itemRow: { nID: any; }) => {
        DialogFn.BlockUI();
        let nMaxId = findMaxID();
        let nRowID = itemRow.nID;

        let objNew = {
            nID: nMaxId,
            sExpense: "",
            isMaster: false,
            nParent: nRowID,
            nFundExpenseID: null,
            nLevel: 2,
            nOrder: nMaxId,
            nTotal: null,
            nQ1: null,
            nQ2: null,
            nQ3: null,
            nQ4: null,
            lstExpenseMonth: _.cloneDeep(arrMock),
            lstSubLevel: []
        }
        appendTwo(objNew);
        setTimeout(() => {
            DialogFn.UnBlockUI();
        }, 1000)
    }

    const handleRemove = (index: number) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
            DialogFn.CloseSubmit();
            removeTwo(index);
        });
    }


    return (
        <>
            <TableRow sx={{ backgroundColor: "#ffdbaa" }}>
                <TableCell className="sticky-cell pad-0" sx={{ backgroundColor: "#ffdbaa !important" }}>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '110px', width: '110px' }}>
                        {!isView && <BtnAdd
                            IsCircleWithOutText
                            id={'btnAdd' + itemRowLevel1.nID}
                            onClick={() => {
                                handleAddRowlevelTwo(itemRowLevel1);
                            }}
                        />}
                    </TableCell>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}>{indexLevel1 + 1}</TableCell>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='left' style={{ minWidth: '300px', width: '300px' }}>
                        {itemRowLevel1.sExpense}
                    </TableCell>
                </TableCell>
                {
                    !itemRowLevel1.lstExpenseMonth ? null :
                        itemRowLevel1.lstExpenseMonth.map((keyRow: { value: string | number; }, indexMonth: number) => {
                            return (
                                <>
                                    <TableCell
                                        padding='none'
                                    >
                                        <InputReactNumber   //InputReactNumber      //InputNumberIncomeExpense
                                            id={`lstExpensePlan[${indexLevel1}].lstExpenseMonth[${indexMonth}].value`}
                                            name={`lstExpensePlan[${indexLevel1}].lstExpenseMonth[${indexMonth}].value`}
                                            defaultValue={keyRow.value}
                                            required={false}
                                            maxInteger={18}
                                            disabled={isView || controlledFieldsLevel2.length !== 0}
                                            IsCanMinus={false}
                                            IsShowMessageError={false}
                                            onChange={(eValue) => {
                                                setValue(`lstExpensePlan[${indexLevel1}].lstExpenseMonth[${indexMonth}].value`, parseFloatCheckValue(eValue));
                                                handleChangeValueLevelOne(eValue, indexMonth, keyRow, itemRowLevel1);
                                            }}
                                        />
                                    </TableCell>
                                    {
                                        [2, 5, 8, 11].includes(indexMonth) ?
                                            <TableCell padding='none'>
                                                {/* <TextFieldInputNumber
                                                    value={itemRowLevel1["nQ" + calIndexOld(indexMonth)] ? formatNumber(itemRowLevel1["nQ" + calIndexOld(indexMonth)], 2) : ""}
                                                    digit={2}
                                                /> */}
                                                <TextField
                                                    id={"level1_total" + indexMonth}
                                                    name={"level1_total" + indexMonth}
                                                    value={itemRowLevel1["nQ" + calIndexOld(indexMonth)] ? formatNumber(itemRowLevel1["nQ" + calIndexOld(indexMonth)], 2) : ""}
                                                    variant={"outlined"}
                                                    type={"text"}
                                                    size={"small"}
                                                    fullWidth={true}
                                                    disabled
                                                    inputProps={{
                                                        style: {
                                                            textAlign: "right",
                                                        }
                                                    }}
                                                />
                                            </TableCell>
                                            :
                                            null
                                    }
                                    {
                                        [11].includes(indexMonth) ?
                                            <TableCell
                                                padding='none'
                                            >
                                                {/* <TextFieldInputNumber
                                                    value={itemRowLevel1.nTotal ? formatNumber(itemRowLevel1.nTotal, 2) : ""}
                                                    digit={2}
                                                /> */}
                                                <TextField
                                                    id={"level1_total"}
                                                    name={"level1_total"}
                                                    value={itemRowLevel1.nTotal ? formatNumber(itemRowLevel1.nTotal, 2) : ""}
                                                    variant={"outlined"}
                                                    type={"text"}
                                                    size={"small"}
                                                    fullWidth={true}
                                                    disabled
                                                    inputProps={{
                                                        style: {
                                                            textAlign: "right",
                                                        }
                                                    }}
                                                />
                                            </TableCell>
                                            :
                                            null
                                    }
                                </>
                            )
                        })
                }
            </TableRow>
            {
                controlledFieldsLevel2.map((itemRowLevel2, indexLevel2) => {
                    let keyCellTable = keyId + itemRowLevel2.nID;
                    return (
                        <Fragment key={keyCellTable}>
                            <NestedArrayLevel23
                                handleRemove={handleRemove}
                                itemRowLevel2={itemRowLevel2}
                                indexLevel1={indexLevel1}
                                indexLevel2={indexLevel2}
                                keyId={keyId}
                                {...{ control, setValue, watch, reset }}
                            />
                        </Fragment>
                    )
                })
            }
        </>
    );
}

function NestedArrayLevel23({ handleRemove, itemRowLevel2, indexLevel1, indexLevel2, control, setValue, watch, keyId, reset }) {

    const {
        arrMock,
        calIndexOld,
        findMaxID,
        isView,
    } = useContext(ProviderExpensePlan);
    const DialogFn = FnDialog();

    const { fields, remove, append, insert } = useFieldArray({
        control,
        name: `lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.lstSubLevel`
    });

    const watchFieldArray = watch(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.lstSubLevel`);

    const controlledFieldsLevel3 = useMemo(() => {
        return fields.map((field, index) => {
            return {
                ...field,
                ...watchFieldArray[index]
            };
        });

    }, [fields, watchFieldArray])

    const handleChangeValueLevelTwo = (eValue: any, indexMonth: any, indexRow: any, itemTable: any) => {
        handleLevelTwoInDebounced.cancel();
        handleLevelTwoInDebounced(eValue, indexMonth, indexRow, itemTable);
    }

    const handleLevelTwoInDebounced = debounce((eValue: any, indexMonth: number, keyRow: { value: number; }, itemTable) => {
        // Your delayed logic or state update here
        let sumQ1 = parseFloatCheckValue(itemTable.nQ1) ?? 0;
        let sumQ2 = parseFloatCheckValue(itemTable.nQ2) ?? 0;
        let sumQ3 = parseFloatCheckValue(itemTable.nQ3) ?? 0;
        let sumQ4 = parseFloatCheckValue(itemTable.nQ4) ?? 0;
        let nTotal = 0;
        keyRow.value = parseFloatCheckValue(eValue);
        if ([0, 1, 2].includes(indexMonth)) {
            // Q1
            sumQ1 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [1, 2, 3].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.nQ1`, sumQ1)
        }
        else if ([3, 4, 5].includes(indexMonth)) {
            // Q2
            sumQ2 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [4, 5, 6].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.nQ2`, sumQ2)
        }
        else if ([6, 7, 8].includes(indexMonth)) {
            // Q3
            sumQ3 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [7, 8, 9].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.nQ3`, sumQ3)
        }
        else {
            // Q4
            sumQ4 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [10, 11, 12].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.nQ4`, sumQ4)
        }
        nTotal = sumQ1 + sumQ2 + sumQ3 + sumQ4;
        setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.nTotal`, nTotal)

        // Calculate parent Level 2 for set Level 1
        let lstExpensePlan = [watch(`lstExpensePlan.${indexLevel1}`)];

        lstExpensePlan.forEach((level1) => {
            let nQ1 = _.sumBy(level1.lstSubLevel, (item: any) => _.get(item, 'nQ1', 0));
            let nQ2 = _.sumBy(level1.lstSubLevel, (item: any) => _.get(item, 'nQ2', 0));
            let nQ3 = _.sumBy(level1.lstSubLevel, (item: any) => _.get(item, 'nQ3', 0));
            let nQ4 = _.sumBy(level1.lstSubLevel, (item: any) => _.get(item, 'nQ4', 0));
            level1.nQ1 = nQ1 !== 0 ? nQ1 : null;
            level1.nQ2 = nQ2 !== 0 ? nQ2 : null;
            level1.nQ3 = nQ3 !== 0 ? nQ3 : null;
            level1.nQ4 = nQ4 !== 0 ? nQ4 : null;
            level1.nTotal = nQ1 + nQ2 + nQ3 + nQ4;

            level1.lstExpenseMonth.forEach((eleInput: { nOrder: number; value: any; }) => {
                let sPathValue = `lstExpenseMonth[${eleInput.nOrder - 1}].value`;
                let nSum = _.sumBy(level1.lstSubLevel, (item: any) => _.get(item, sPathValue, 0));
                eleInput.value = nSum !== 0 ? nSum : null;
            });
        });

        reset({
            ...watch(),
        });
    }, 500);

    const handleChangeValueLevelThree = (eValue: any, indexMonth: any, keyRow: any, itemTable: any, indexRow: number) => {
        handleLevelThreeInDebounced.cancel();
        handleLevelThreeInDebounced(eValue, indexMonth, keyRow, itemTable, indexRow);
    }

    const handleLevelThreeInDebounced = debounce((eValue: any, indexMonth: number, keyRow: { value: number; }, itemTable, indexLevel3: any) => {
        // Your delayed logic or state update here
        let sumQ1 = parseFloatCheckValue(itemTable.nQ1) ?? 0;
        let sumQ2 = parseFloatCheckValue(itemTable.nQ2) ?? 0;
        let sumQ3 = parseFloatCheckValue(itemTable.nQ3) ?? 0;
        let sumQ4 = parseFloatCheckValue(itemTable.nQ4) ?? 0;
        let nTotal = 0;
        keyRow.value = parseFloatCheckValue(eValue);
        if ([0, 1, 2].includes(indexMonth)) {
            // Q1
            sumQ1 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [1, 2, 3].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.lstSubLevel.${indexLevel3}.nQ1`, sumQ1)
        }
        else if ([3, 4, 5].includes(indexMonth)) {
            // Q2
            sumQ2 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [4, 5, 6].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.lstSubLevel.${indexLevel3}.nQ2`, sumQ2)
        }
        else if ([6, 7, 8].includes(indexMonth)) {
            // Q3
            sumQ3 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [7, 8, 9].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.lstSubLevel.${indexLevel3}.nQ3`, sumQ3)
        }
        else {
            // Q4
            sumQ4 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [10, 11, 12].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.lstSubLevel.${indexLevel3}.nQ4`, sumQ4)
        }
        nTotal = sumQ1 + sumQ2 + sumQ3 + sumQ4;
        setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.lstSubLevel.${indexLevel3}.nTotal`, nTotal)

        let lstExpensePlan = [watch(`lstExpensePlan.${indexLevel1}`)];

        lstExpensePlan.forEach((level1) => {
            //cal level 2
            // if (level1.lstSubLevel != null && level1.lstSubLevel.length !== 0) {
            // }
            level1.lstSubLevel.forEach((level2) => {
                if (level2.lstSubLevel != null && level2.lstSubLevel.length !== 0) {
                    let nQ1 = _.sumBy(level2.lstSubLevel, (item: any) => _.get(item, 'nQ1', 0));
                    let nQ2 = _.sumBy(level2.lstSubLevel, (item: any) => _.get(item, 'nQ2', 0));
                    let nQ3 = _.sumBy(level2.lstSubLevel, (item: any) => _.get(item, 'nQ3', 0));
                    let nQ4 = _.sumBy(level2.lstSubLevel, (item: any) => _.get(item, 'nQ4', 0));

                    level2.nQ1 = nQ1 !== 0 ? nQ1 : null;
                    level2.nQ2 = nQ2 !== 0 ? nQ2 : null;
                    level2.nQ3 = nQ3 !== 0 ? nQ3 : null;
                    level2.nQ4 = nQ4 !== 0 ? nQ4 : null;
                    level2.nTotal = nQ1 + nQ2 + nQ3 + nQ4;
                    level2.lstExpenseMonth.forEach((eleInput: { nOrder: number; value: any; }) => {
                        let sPathValue = `lstExpenseMonth[${eleInput.nOrder - 1}].value`;
                        let nSum = _.sumBy(level2.lstSubLevel, (item: any) => _.get(item, sPathValue, 0));
                        eleInput.value = nSum !== 0 ? nSum : null;
                    });
                }
            })

            //cal level 1
            let nQ1 = _.sumBy(level1.lstSubLevel, (item: any) => _.get(item, 'nQ1', 0));
            let nQ2 = _.sumBy(level1.lstSubLevel, (item: any) => _.get(item, 'nQ2', 0));
            let nQ3 = _.sumBy(level1.lstSubLevel, (item: any) => _.get(item, 'nQ3', 0));
            let nQ4 = _.sumBy(level1.lstSubLevel, (item: any) => _.get(item, 'nQ4', 0));
            level1.nQ1 = nQ1 !== 0 ? nQ1 : null;
            level1.nQ2 = nQ2 !== 0 ? nQ2 : null;
            level1.nQ3 = nQ3 !== 0 ? nQ3 : null;
            level1.nQ4 = nQ4 !== 0 ? nQ4 : null;
            level1.nTotal = nQ1 + nQ2 + nQ3 + nQ4;
            level1.lstExpenseMonth.forEach((eleInput: { nOrder: number; value: any; }) => {
                let sPathValue = `lstExpenseMonth[${eleInput.nOrder - 1}].value`;
                let nSum = _.sumBy(level1.lstSubLevel, (item: any) => _.get(item, sPathValue, 0));
                eleInput.value = nSum !== 0 ? nSum : null;
            });
        });

        reset({
            ...watch(),
        });
    }, 500);

    const handleAddRowlevelThree = (itemRow: { nID: any; }, indexInsert) => {
        DialogFn.BlockUI();
        let nMaxId = findMaxID();
        let nRowID = itemRow.nID;
        let objNew = {
            nID: nMaxId,
            sExpense: "",
            isMaster: false,
            nParent: nRowID,
            nFundExpenseID: null,
            nLevel: 3,
            nOrder: nMaxId,
            nTotal: null,
            nQ1: null,
            nQ2: null,
            nQ3: null,
            nQ4: null,
            lstExpenseMonth: _.cloneDeep(arrMock),
            lstSubLevel: []
        }

        if (indexInsert != null) {
            insert(indexInsert + 1, objNew);
        }
        else {
            append(objNew);
        }

        setTimeout(() => {
            DialogFn.UnBlockUI();
        }, 1000)
    }

    const handleRemoveThree = (index: number) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
            DialogFn.CloseSubmit();
            remove(index);
        });
    }

    return (
        <>
            <TableRow sx={{ backgroundColor: "#eae6e6" }}>
                <TableCell className="sticky-cell pad-0" padding='none' sx={{ backgroundColor: "#eae6e6 !important" }}>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '110px', width: '110px' }}>
                        {!isView && <BtnAdd
                            IsCircleWithOutText
                            id={'btnAdd' + itemRowLevel2.nID}
                            onClick={() => {
                                handleAddRowlevelThree(itemRowLevel2, null);
                            }}
                        />}
                        {" "}
                        {itemRowLevel2.isMaster || isView ? null :
                            <BtnDelete
                                IsCircleWithOutText
                                id={'btnDelete' + itemRowLevel2.nID}
                                onClick={() => handleRemove(indexLevel2)}
                            />
                        }
                    </TableCell>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}>{indexLevel1 + 1 + "." + (indexLevel2 + 1)}</TableCell>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='left' style={{ minWidth: '300px', width: '300px' }}>
                        {itemRowLevel2.isMaster ? itemRowLevel2.sExpense :
                            <TextBoxItem
                                id={`lstExpensePlan[${indexLevel1}].lstSubLevel[${indexLevel2}].sExpense`}
                                name={`lstExpensePlan[${indexLevel1}].lstSubLevel[${indexLevel2}].sExpense`}
                                defaultValue={itemRowLevel2.sExpense}
                                required={true}
                                maxLength={250}
                                IsShowMessageError={false}
                            />
                        }
                    </TableCell>
                </TableCell>
                {
                    !itemRowLevel2.lstExpenseMonth ? null :
                        itemRowLevel2.lstExpenseMonth.map((keyRow: { value: string | number; }, indexMonth: number) => {
                            return (
                                <>
                                    <TableCell
                                        padding='none'
                                    >
                                        <InputReactNumber   //InputReactNumber      //InputNumberIncomeExpense
                                            id={`lstExpensePlan[${indexLevel1}].lstSubLevel[${indexLevel2}].lstExpenseMonth[${indexMonth}].value`}
                                            name={`lstExpensePlan[${indexLevel1}].lstSubLevel[${indexLevel2}].lstExpenseMonth[${indexMonth}].value`}
                                            defaultValue={keyRow.value}
                                            required={false}
                                            maxInteger={18}
                                            disabled={isView || controlledFieldsLevel3.length !== 0}
                                            IsCanMinus={false}
                                            IsShowMessageError={false}
                                            onChange={(eValue) => {

                                                setValue(`lstExpensePlan[${indexLevel1}].lstSubLevel[${indexLevel2}].lstExpenseMonth[${indexMonth}].value`, parseFloatCheckValue(eValue));
                                                handleChangeValueLevelTwo(eValue, indexMonth, keyRow, itemRowLevel2);

                                            }}
                                        />
                                    </TableCell>
                                    {
                                        [2, 5, 8, 11].includes(indexMonth) ?
                                            <TableCell padding='none'>
                                                {/* <TextFieldInputNumber
                                                    value={itemRowLevel2["nQ" + calIndexOld(indexMonth)] ? formatNumber(itemRowLevel2["nQ" + calIndexOld(indexMonth)], 2) : ""}
                                                    digit={2}
                                                /> */}
                                                <TextField
                                                    id={"level1_total" + indexMonth}
                                                    name={"level1_total" + indexMonth}
                                                    value={itemRowLevel2["nQ" + calIndexOld(indexMonth)] ? formatNumber(itemRowLevel2["nQ" + calIndexOld(indexMonth)], 2) : ""}
                                                    variant={"outlined"}
                                                    type={"text"}
                                                    size={"small"}
                                                    fullWidth={true}
                                                    disabled
                                                    inputProps={{
                                                        style: {
                                                            textAlign: "right",
                                                        }
                                                    }}
                                                />
                                            </TableCell>
                                            :
                                            null
                                    }
                                    {
                                        [11].includes(indexMonth) ?
                                            <TableCell
                                                padding='none'
                                            >
                                                {/* <TextFieldInputNumber
                                                    value={itemRowLevel2.nTotal ? formatNumber(itemRowLevel2.nTotal, 2) : ""}
                                                    digit={2}
                                                /> */}
                                                <TextField
                                                    id={"level1_total"}
                                                    name={"level1_total"}
                                                    value={itemRowLevel2.nTotal ? formatNumber(itemRowLevel2.nTotal, 2) : ""}
                                                    variant={"outlined"}
                                                    type={"text"}
                                                    size={"small"}
                                                    fullWidth={true}
                                                    disabled
                                                    inputProps={{
                                                        style: {
                                                            textAlign: "right",
                                                        }
                                                    }}
                                                />
                                            </TableCell>
                                            :
                                            null
                                    }
                                </>
                            )
                        })
                }
            </TableRow>
            {
                controlledFieldsLevel3.map((itemRowLevel3, indexLevel3) => {
                    let keyCellTable = keyId + itemRowLevel3.nID;
                    return (
                        <Fragment key={keyCellTable}>
                            <TableRow >
                                <TableCell className="sticky-cell pad-0" padding='none' sx={{ backgroundColor: "#ffffff !important" }} style={{ minWidth: '470px', width: '470px' }}>
                                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '110px', width: '110px' }}>
                                        {!isView && <BtnAdd
                                            IsCircleWithOutText
                                            id={'btnAdd' + itemRowLevel3.nID}
                                            onClick={() => {
                                                handleAddRowlevelThree(itemRowLevel3, indexLevel3);
                                            }}
                                        />}
                                        {" "}
                                        {itemRowLevel3.isMaster || isView ? null :
                                            <BtnDelete
                                                IsCircleWithOutText
                                                id={'btnDelete' + itemRowLevel3.nID}
                                                onClick={() => handleRemoveThree(indexLevel3)}
                                            />
                                        }
                                    </TableCell>
                                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}></TableCell>
                                    <TableCell className='cell-in-sticky border-l' padding='none' align='left' style={{ minWidth: '300px', width: '300px' }}>
                                        {itemRowLevel3.isMaster ? itemRowLevel3.sExpense :
                                            <TextBoxItem
                                                id={`lstExpensePlan[${indexLevel1}].lstSubLevel[${indexLevel2}].lstSubLevel[${indexLevel3}].sExpense`}
                                                name={`lstExpensePlan[${indexLevel1}].lstSubLevel[${indexLevel2}].lstSubLevel[${indexLevel3}].sExpense`}
                                                defaultValue={itemRowLevel3.sExpense ?? null}
                                                required={true}
                                                maxLength={250}
                                                disabled={isView}
                                                IsShowMessageError={false}
                                            />}
                                    </TableCell>
                                </TableCell>
                                {
                                    !itemRowLevel3.lstExpenseMonth ? null :
                                        itemRowLevel3.lstExpenseMonth.map((keyRow: { value: string | number; name: string; }, indexMonth: number) => {
                                            return (
                                                <>
                                                    <TableCell
                                                        padding='none'
                                                    >
                                                        <InputReactNumber   //InputReactNumber      //InputNumberIncomeExpense
                                                            id={`lstExpensePlan[${indexLevel1}].lstSubLevel[${indexLevel2}].lstSubLevel[${indexLevel3}].lstExpenseMonth[${indexMonth}].value`}
                                                            name={`lstExpensePlan[${indexLevel1}].lstSubLevel[${indexLevel2}].lstSubLevel[${indexLevel3}].lstExpenseMonth[${indexMonth}].value`}
                                                            defaultValue={keyRow.value ?? null}
                                                            required={false}
                                                            maxInteger={18}
                                                            disabled={isView}
                                                            IsCanMinus={false}
                                                            IsShowMessageError={false}
                                                            onChange={(eValue) => {
                                                                setValue(`lstExpensePlan[${indexLevel1}].lstSubLevel[${indexLevel2}].lstSubLevel[${indexLevel3}].lstExpenseMonth[${indexMonth}].value`, parseFloatCheckValue(eValue));
                                                                handleChangeValueLevelThree(eValue, indexMonth, keyRow, itemRowLevel3, indexLevel3)
                                                            }}
                                                        />
                                                    </TableCell>
                                                    {
                                                        [2, 5, 8, 11].includes(indexMonth) ?
                                                            <TableCell padding='none'>
                                                                {/* <TextFieldInputNumber
                                                                    value={itemRowLevel3["nQ" + calIndexOld(indexMonth)] ? formatNumber(itemRowLevel3["nQ" + calIndexOld(indexMonth)], 2) : ""}
                                                                    digit={2}
                                                                /> */}
                                                                <TextField
                                                                    id={"level1_total" + indexMonth}
                                                                    name={"level1_total" + indexMonth}
                                                                    value={itemRowLevel3["nQ" + calIndexOld(indexMonth)] ? formatNumber(itemRowLevel3["nQ" + calIndexOld(indexMonth)], 2) : ""}
                                                                    variant={"outlined"}
                                                                    type={"text"}
                                                                    size={"small"}
                                                                    fullWidth={true}
                                                                    disabled
                                                                    inputProps={{
                                                                        style: {
                                                                            textAlign: "right",
                                                                        }
                                                                    }}
                                                                />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        [11].includes(indexMonth) ?
                                                            <TableCell
                                                                padding='none'
                                                            >
                                                                {/* <TextFieldInputNumber
                                                                    value={itemRowLevel3.nTotal ? formatNumber(itemRowLevel3.nTotal, 2) : ""}
                                                                    digit={2}
                                                                /> */}
                                                                <TextField
                                                                    id={"level1_total"}
                                                                    name={"level1_total"}
                                                                    value={itemRowLevel3.nTotal ? formatNumber(itemRowLevel3.nTotal, 2) : ""}
                                                                    variant={"outlined"}
                                                                    type={"text"}
                                                                    size={"small"}
                                                                    fullWidth={true}
                                                                    disabled
                                                                    inputProps={{
                                                                        style: {
                                                                            textAlign: "right",
                                                                        }
                                                                    }}
                                                                />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                </>
                                            )
                                        })
                                }
                            </TableRow>
                        </Fragment>
                    )
                })
            }
        </>
    );
};

